var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9503 8.1042L10.7061 2.76739C11.6394 2.03008 12.963 2.05245 13.8709 2.82088L20.1151 8.10594C20.6763 8.58095 21 9.27893 21 10.0142V18.0001C21 19.3808 19.8807 20.5001 18.5 20.5001H5.5C4.11929 20.5001 3 19.3808 3 18.0001V10.0659C3 9.30108 3.35012 8.57832 3.9503 8.1042ZM12.0001 12.1362C11.5152 12.1362 11.122 12.5294 11.122 13.0143V15.3491C11.122 15.834 11.5152 16.2272 12.0001 16.2272C12.485 16.2272 12.8781 15.834 12.8781 15.3491V13.0143C12.8781 12.5294 12.485 12.1362 12.0001 12.1362Z",
    fill: "#0376C9"
  })));
};
export default SvgHome;